/**
 * Assets mapping file for MeetMinutes
 * This file contains references to all assets used in the website
 * Each asset has a comment describing its purpose and location on the page
 */

export const assets = {
  // Main logo used in navbar and footer
  logo: "/images/logo.svg",

  // Hero section assets
  heroPrimary: "/images/hero-dashboard.png", // Main hero image
  heroSecondary: "/images/hero-secondary.gif", // Hero section decorative animation

  // Trusted by brands section
  brandLogos: [
    // Brand logos shown in the "Trusted by 100+ top brands" section
    "/images/brands/wns.png",
    "/images/brands/aetna.png",
    "/images/brands/ag4good.png",
    "/images/brands/aramco.png",
    "/images/brands/arm_holdings.png",
    "/images/brands/capgemini.png",
    "/images/brands/cbec.png",
    "/images/brands/celeris.png",
    "/images/brands/conta_azul.png",
    "/images/brands/crm_excellence.png",
    "/images/brands/dubai_real_estate.png",
    "/images/brands/g-square.png",
  ],

  // Feature section icons
  featureIcons: {
    accurateSummaries: "/images/summary-icon.svg",
    chatAcross: "/images/chat-icon.svg",
    taskManagement: "/images/task-icon.svg",
  },

  // Product Capabilities section 
  productCapabilities: {
    calendarSync: "/images/calendar-sync.webp",
    multilingual: "/images/multilingual.png",
    insights: "/images/insights.webp",
  },

  // Platform compatibility section
  platformLogos: {
    googleMeet: "/images/gmeet.png",
    msTeams: "/images/teams.webp",
    zoom: "/images/zoom.png",
    webex: "/images/webex.png",
    other: "/images/other-meetings.png",
  },

  // Advanced features icons
  advancedFeatures: {
    search: "/images/search-icon.svg",
    taskManagement: "/images/task-management-icon.svg",
    sharing: "/images/share-icon.svg",
    security: "/images/security-icon.png",
  },

  // Testimonial images
  testimonials: {
    gopi: "/images/testimonials/gopi.jpeg",
    erika: "/images/testimonials/erika.jpg",
    andrew: "/images/testimonials/andrew.jpeg",
    justin: "/images/testimonials/justin.jpeg", 
    adel: "/images/testimonials/adel.jpeg",
    tanuj: "/images/testimonials/tanuj.jpeg",
    smriti_raheja: "/images/testimonials/smriti_raheja.jpeg",
  },

  // Social media icons
  socialIcons: {
    linkedin: "/images/social/linkedin.svg",
    twitter: "/images/social/twitter.svg",
  },

  // Product Hunt badge
  productHuntBadge: "/images/top-post-badge.svg",
};
